// extracted by mini-css-extract-plugin
export default {"container":"Video_container__F2Txv","background":"Video_background__dlNXa","closeButton":"Video_closeButton__rTyW+","box":"Video_box__btC6W"};